if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // 1. RECUPERO VALORI DAL MODAL (Usiamo i nuovi ID fissi)
        const inputInitialsEl = document.getElementById('Input-Pers-Initials');
        const colorRadio = document.querySelector('.mObs-swatch-radio:checked');
        const fontRadio = document.querySelector('.mObs-font-radio:checked');
        const confirmCheckbox = document.getElementById('ConfirmCheck-Pers');

        let currentInitials = inputInitialsEl ? inputInitialsEl.value.trim() : "";
        let currentColor = colorRadio ? colorRadio.value.trim() : "";
        let currentColorId = colorRadio ? colorRadio.dataset.colorId : "";
        let currentFont = fontRadio ? fontRadio.value.trim() : "";

        // 2. RECUPERO CHIAVI LINGUA (Inclusa la nuova chiave Font)
        let keyInitials = document.getElementById('force-key-initials')?.value || "Initials";
        let keyColor = document.getElementById('force-key-color')?.value || "Color";
        let keyFont = document.getElementById('force-key-font')?.value || "Font Style";

        // 3. LOGICA DI PERSONALIZZAZIONE
        const isPersonalized = currentInitials.length > 0;
        const dynamicLimit = isPersonalized ? 1 : 3;
        
        // Il fingerprint serve a distinguere i prodotti nel carrello
        const fingerprint = isPersonalized ? `${currentInitials.toLowerCase().replace(/\s/g, '')}_${currentColorId}_${currentFont.toLowerCase()}` : "";
        
        const variantId = String(new FormData(this.form).get('id'));
        const qtyToAdd = parseInt(new FormData(this.form).get('quantity') || 1);

        // 4. VALIDAZIONE
       // 4. VALIDAZIONE
        if (isPersonalized) {
            // Se mancano dati o la checkbox non è spuntata
            const regex = /^(?:[a-zA-Z0-9]\.?){2,3}$/;
            
            if (currentColor === "" || !regex.test(currentInitials) || (confirmCheckbox && !confirmCheckbox.checked)) {
                // ERRORE: Apriamo il modal per far correggere l'utente
                const overlay = document.getElementById('mObs-pers-overlay');
                if (overlay) {
                    overlay.classList.add('is-active');
                    document.body.style.overflow = 'hidden';
                }
                this.handleErrorMessage(window.productMessages.invalidFormat || "Controlla i dati e conferma la personalizzazione");
                return;
            }
        }
        
        this.handleErrorMessage(false);

        // 5. CONTROLLO LIMITI CARRELLO
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart.js?t=${Date.now()}`);
          const cart = await response.json();
          let existingQty = 0;
          cart.items.forEach(item => {
            if (String(item.variant_id) === variantId) {
              const itemProps = item.properties || {};
              if (isPersonalized) {
                if (itemProps['_fingerprint'] === fingerprint) existingQty += item.quantity;
              } else {
                if (!itemProps['_fingerprint']) existingQty += item.quantity;
              }
            }
          });
          if (existingQty + qtyToAdd > dynamicLimit) {
            this.handleErrorMessage(isPersonalized ? window.productMessages.limitPersonalized : window.productMessages.limitNormal);
            return; 
          }
        } catch (e) { console.error("Limit check error:", e); }

        // 6. PREPARAZIONE DATI DA INVIARE
        const cleanData = new FormData();
        cleanData.append('id', variantId);
        cleanData.append('quantity', qtyToAdd);

        if (isPersonalized) {
             cleanData.append(`properties[${keyInitials}]`, currentInitials);
             cleanData.append(`properties[${keyColor}]`, currentColor);
             cleanData.append(`properties[${keyFont}]`, currentFont);
             cleanData.append('properties[_fingerprint]', fingerprint);
        }

        if (this.cart) {
          cleanData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          cleanData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // 7. INVIO EFFETTIVO
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = cleanData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            if (!this.cart) { window.location = window.routes.cart_url; return; }
            
            // Trigger per mo-cart.js e Drawer
            if (window.publish) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: response });
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
            
            this.cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        if (!this.errorMessageWrapper) return;
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}